<!-- SECTION: Mobile일 때 Floating Drawer
      ====================================================================== -->

<template>
  <v-btn id="floatingIcon" v-show="!isDesktop" fab medium>
    <v-app-bar-nav-icon @click.stop="drawerChg" id="icon" />
  </v-btn>
</template>
<script>
export default {
  name: "FloatingIcon",
  data() {
    return {};
  },
  watch: {
    isDesktop: (value) => {
      if (value) {
        return false;
      } else {
        return true;
      }
    },
  },
  computed: {
    isDesktop() {
      return !this.$vuetify.breakpoint.mobile;
    },
  },
  methods: {
    drawerChg() {
      this.$parent.$children.map(function (value, key) {
        if (value.$options._componentTag === "AppBar") {
          value.drawer = !value.drawer;
          value.mini = false;
        }
      });
    },
  },

  mounted() {},
};
</script>
<style lang="scss">
#floatingIcon {
  align-self: start;
  bottom: 60px;
  left: 20px;
  color: bisque;
  position: sticky;
  z-index: 2;
}
.theme--light.v-btn.v-btn--has-bg {
  background-color: #f8f3eb;
}
</style>
